<template>
    <div>
        <div @click="toggle">
            <slot @click="toggle" name="collapsed" v-bind:expanded="expanded" />
        </div>

        <div class="flex" v-if="expanded">
            <slot name="expanded" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                expanded: false
            }
        },

        methods: {
            toggle() {
                this.expanded = !this.expanded;
            }
        }
    }
</script>
